// Upload configuration constants
import { getEnv } from '../config/env';
import { RETRY_CONFIG } from './apiConfig';

// Re-export RETRY_CONFIG for backward compatibility
export { RETRY_CONFIG };

// Upload Performance Configuration
export const UPLOAD_CONFIG = {
    // Maximum number of parallel chunk uploads per file
    maxParallelChunks: parseInt(getEnv('VITE_MAX_PARALLEL_CHUNKS') || '10', 10),
    
    // Maximum number of files to process in parallel
    maxParallelFiles: parseInt(getEnv('VITE_MAX_PARALLEL_FILES') || '5', 10),
    
    // Default chunk size (10MB) - server will override this
    defaultChunkSize: parseInt(getEnv('VITE_DEFAULT_CHUNK_SIZE') || String(10 * 1024 * 1024), 10),
    
    // Maximum files per batch request to backend (for sequential batching)
    // Must not exceed backend's MAX_NUMBER_OF_FILES_IN_ONE_REQUEST limit (500)
    batchSize: parseInt(getEnv('VITE_BATCH_SIZE') || '100', 10),

    // Maximum total bytes per batch (40 GB default — mirrors backend ingestor limit)
    // Batches are split when EITHER the file count OR this byte limit would be exceeded
    maxBatchSizeBytes: parseInt(getEnv('VITE_MAX_BATCH_SIZE_BYTES') || String(40 * 1024 * 1024 * 1024), 10),
    
    // Auto-retry configuration for failed uploads
    autoRetry: {
        // Enable automatic retry of failed files after upload completes
        enabled: getEnv('VITE_AUTO_RETRY_ENABLED') !== 'false', // Default: true
        
        // Maximum number of automatic retry attempts (0 = no retry, 1 = one retry, etc.)
        maxAttempts: parseInt(getEnv('VITE_AUTO_RETRY_ATTEMPTS') || '1', 10),
        
        // Delay in milliseconds between retry attempts (0 = immediate)
        delayMs: parseInt(getEnv('VITE_AUTO_RETRY_DELAY_MS') || '0', 10),
        
        // Whether to retry locked file errors (usually won't help)
        retryLockedFiles: getEnv('VITE_RETRY_LOCKED_FILES') === 'true' // Default: false
    },

    //URL expiry refresh configuration
    // When presigned URLs expire (HTTP 403 "Request has expired"), all workers stop
    // and fresh URLs are fetched. This controls how many times that can happen.
    maxUrlRefreshes: parseInt(getEnv('VITE_MAX_URL_REFRESHES') || '10', 10)
};

// Export individual constants for backward compatibility
export const MAX_PARALLEL_UPLOADS = UPLOAD_CONFIG.maxParallelChunks;
export const MAX_PARALLEL_FILES = UPLOAD_CONFIG.maxParallelFiles;
export const BATCH_SIZE = UPLOAD_CONFIG.batchSize;
export const MAX_BATCH_SIZE_BYTES = UPLOAD_CONFIG.maxBatchSizeBytes;

// Export auto-retry configuration
export const AUTO_RETRY_CONFIG = UPLOAD_CONFIG.autoRetry;

//Export URL refresh limit
export const MAX_URL_REFRESHES = UPLOAD_CONFIG.maxUrlRefreshes;

// File Size Limits (individual file - currently disabled)
export const MAX_FILE_SIZE_GB = parseInt(getEnv('VITE_MAX_FILE_SIZE_GB') || '25', 10);
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_GB * 1024 * 1024 * 1024;

// Upload Limits (enforced via UI)
export const MAX_TOTAL_SIZE_GB = parseInt(getEnv('VITE_MAX_TOTAL_SIZE_GB') || '50', 10);
export const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_GB * 1024 * 1024 * 1024; // 50 GB default

export const MAX_SINGLE_FILE_SIZE_GB = parseInt(getEnv('VITE_MAX_SINGLE_FILE_SIZE_GB') || '40', 10);
export const MAX_SINGLE_FILE_SIZE_BYTES = MAX_SINGLE_FILE_SIZE_GB * 1024 * 1024 * 1024; // 40 GB default

export const MAX_FILE_COUNT = parseInt(getEnv('VITE_MAX_FILE_COUNT') || '25000', 10); // 25,000 files default

// File Validation Display
export const MAX_FILES_TO_SHOW = 3; // Maximum number of files to show in skip notifications

export const LOGIN_PATH = '/login';

// ===================== Upload summary UI strings =====================
export const UPLOAD_SUMMARY_TITLE = 'Upload Summary';
export const UPLOAD_SUMMARY_DISCLAIMER = 'Some files may still be processing. Final counts may differ from the values shown above.';
 
export const GENERIC_UNPROCESSABLE_UPLOAD_MESSAGE = 'Unable to process one or more submitted files due to unprocessable data';